import {
  PostAdjusterAttachedImagesPropsType,
  PostAdjusterAttachedImagesQueryParamsType,
} from '@/modules/adjusterReportModules/IncidentParticipants/queries/postDamagedAdjusterAttachedImages/postAdjusterAttachedImagesQuery.type';
import { postAdjusterAttachedImagesFunction } from '@/modules/adjusterReportModules/IncidentParticipants/queries/postDamagedAdjusterAttachedImages/postAdjusterAttachedImagesQueryFunction';

export const postAdjusterAttachedImagesQueryOptions = ({
  type,
  fileType,
}: PostAdjusterAttachedImagesPropsType) => {
  return {
    mutationKey: ['postAdjusterAttachedImages'],
    mutationFn: (params: PostAdjusterAttachedImagesQueryParamsType) =>
      postAdjusterAttachedImagesFunction({ ...params, type, fileType }),
  };
};
